import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Works from "../pages/works/page";
import Circles from "../pages/circles/page";
import PostDetail from "../pages/post/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/works",
    element: <Works />,
  },
  {
    path: "/circles",
    element: <Circles />,
  },
  {
    path: "/post/:id",
    element: <PostDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;